import { takeLatest, put, select, call } from 'redux-saga/effects';

import quoteItemService from 'modules/quotes/quoteItems/data/service';
import { UPDATE_COMPONENT_SUCCESS } from 'modules/quotes/quoteItems/data/types';

import { types } from './actions';
import { liveProfitItemPreview } from './actions';
import {
  getProfitItemId,
  getCurrentOverrides,
  getIsProfitItemModalOpen,
} from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_PROFIT_ITEM_MODAL, watchOpenProfitItemModal);
  yield takeLatest(
    types.LIVE_PROFIT_ITEM_PREVIEW_REQUEST,
    watchLiveProfitItemPreviewRequest,
  );
  yield takeLatest(UPDATE_COMPONENT_SUCCESS, watchUpdateComponentSuccess);
  yield takeLatest(types.RECEIVE_OVERRIDES, watchReceiveOverrides);
}

function* watchOpenProfitItemModal(action) {
  const { payload } = action;
  const { profitItem } = payload;
  yield put(
    liveProfitItemPreview.request({
      profitItemId: profitItem.id,
      newOverrides: profitItem.overrides,
    }),
  );
}

function* watchUpdateComponentSuccess() {
  const profitItemId = yield select(getProfitItemId);
  const overrides = yield select(getCurrentOverrides);
  const isOpen = yield select(getIsProfitItemModalOpen);
  if (isOpen) {
    yield put(
      liveProfitItemPreview.request({
        profitItemId: profitItemId,
        newOverrides: overrides,
      }),
    );
  }
}

function* watchLiveProfitItemPreviewRequest(action) {
  try {
    const { payload } = action;
    const { profitItemId, overrides } = payload;
    const response = yield call(
      quoteItemService.profitItems.livePricing,
      profitItemId,
      {
        overrides,
      },
    );
    yield put(liveProfitItemPreview.success(response));
  } catch (error) {
    console.error(error);
    yield put(liveProfitItemPreview.error);
  }
}

function* watchReceiveOverrides(action) {
  const { payload } = action;
  const { nextOverrides } = payload;
  const profitItemId = yield select(getProfitItemId);
  yield put(
    liveProfitItemPreview.request({
      profitItemId: profitItemId,
      newOverrides: nextOverrides,
    }),
  );
}
